export const DEFAULT_SLIDE_ELEMENT_INDEX = -1;
export const DEFAULT_SLIDE_INDEX = 0;
export const SYSTEM_FONT =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Helvetica, sans-serif';
